import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app';
import { AppErrorBoundary } from './app/AppErrorBoundary';
import { clearStaleChunkGuard, registerStaleChunkReload } from '@/shared/staleChunkReload';
import './styles/book-fonts.css';
import './styles/fonts.css';

// External-audit follow-up (2026-07-27): Sentry is NO LONGER initialised here. The old
// eager `import('@/lib/sentry')` still downloaded the ~474 KB Sentry vendor chunk (tracing
// + replay) on EVERY boot — including the anonymous public landing, which the audit flagged
// as excessive pre-auth loading. Sentry now initialises only for authenticated sessions
// (src/app once `user` is set) and on demand when the error boundary reports (reportError.ts
// → captureBoundaryError, which self-inits). Net: the landing no longer loads Sentry at all.

// Recover a tab left open across a deploy: its lazy route chunks no longer exist on the server
// (releases are pruned to the newest 5), so Vite's preloadError triggers one reload onto the
// current build. See staleChunkReload.ts.
registerStaleChunkReload();

// Getting this far means the entry chunks loaded, so a previous recovery reload succeeded and the
// guard can be released for the next deploy.
clearStaleChunkGuard(sessionStorage);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* J1 (audit): a top-level boundary so a render crash shows a recoverable fallback
        instead of a blank white page; it reports to Sentry via a lazy import. */}
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
